

















import { Component, Prop, Vue } from "vue-property-decorator";
import { deleteComment } from "../../../helpers/comment-getter";
import { CommentType } from "../../../types";

@Component
export default class Comment extends Vue {
  @Prop() private comment!: CommentType;
  @Prop() private position_in_array!: number;

  error = "";

  private is_admin = this.$store.state.user.admin;

  eraseComment() {
    if (!this.comment.id) {
      this.error = "Comment id is not defined…";
      return;
    }

    deleteComment(this.comment.id)
      .then(() => {
        this.$emit("comment-deleted", this.position_in_array);
        this.error = "";
      })
      .catch((err) => {
        this.error = err.message;
      });
  }
}
